module.exports = __webpack_public_path__ + "static/media/others-black-circle.83b18ffd.svg";